<template>
  <section class="loaderContainer" v-show="showLoader">
    <div class="loading" >Wait! Processing...</div>
  </section>
</template>

<script>
 import EventBus from '../../EventBus';
 //blurredBg
  export default {
      data(){
        return {
          showLoader: false
        }
      },
      mounted(){
        this.loaderAnimate();
        EventBus.$on('should-show-loader', (showStatus) => {
            let mainPanel = document.querySelector(".main-panel");
            if(showStatus){
              this.showLoader = true;
              mainPanel.classList.add("blurredBg")
            }
            else{
              this.showLoader = false;
               mainPanel.classList.remove("blurredBg");
            }
        })
      },
      methods:{
         loaderAnimate(){
           let loading = document.querySelector(".loading");
           let letters = loading.textContent.split("");
          loading.textContent = "";
          letters.forEach((letter, i) => {
            let span = document.createElement("span");
            span.textContent = letter;
            span.style.animationDelay = `${i / 10}s`;
            loading.append(span);
          });
         }
      },
      beforeDestroy(){
        EventBus.$off('should-show-loader');
      }
  }
</script>

<style lang="scss" scoped>

</style>